import railsContext from './rails-context'

export default state => railsContext(state).currentUserId
